module.exports = __webpack_public_path__ + "img/Montpellier.0fc97338.png";